module.exports = __webpack_public_path__ + "static/media/prediction.d61e9caa.svg";